export default "__VITE_ASSET__45f67322__"